import { Type } from "@themes/pollinator/ui/Type";
import { OuterContentContainer } from "@themes/pollinator/ui/OuterContentContainer";
import { MarketingContactContainer } from "@platform/features/marketing";

export function ContactPage() {
  return (
    <OuterContentContainer
      className="flex-1 flex flex-col items-center justify-center"
      innerClassName="flex-1 gap-8 py-8 md:py-0"
    >
      <Type as="h1" variant="h2">
        Contact Us
      </Type>

      <MarketingContactContainer />
    </OuterContentContainer>
  );
}

export default ContactPage;


